import HRNumbers from 'human-readable-numbers';
import { Spinner } from "modules/common/components";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import {
  CountData,
  ResponsiveBox,
  StateData,
  TextDataa
} from '../styles/main';

export class LiveCallState extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { list } = this.props;

    if (!list) {
      return <Spinner />
    }

    return (
      <Row className='w-100'>
        {
          Object.keys(list).length && Object.keys(list).map(function (key) {
            return (
              <ResponsiveBox>
                <StateData>
                  <TextDataa>{key ? key : ""}</TextDataa>
                  <CountData>{HRNumbers.toHumanString(list[key] || 0)}</CountData>
                </StateData>
              </ResponsiveBox>
            )
          })
        }
      </Row>

    )
  }
}
LiveCallState.contextTypes = {
  __: PropTypes.func
};

export default LiveCallState;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveCallState.js